import { NgModule } from '@angular/core';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { SharedModule } from '../../../shared/shared.module';
import { DepositDetailDialogComponent } from './deposit-detail-dialog.component';
import { LegfiCurrencyPipe } from '../../../../pipes/format/legfi-currency.pipe';
import { LegfiCurrencyPipeModule } from '../../../../pipes/format/legfi-currency.module';
import { LegfiDatePipe } from '../../../../pipes/format/legfi-date.pipe';
import { LegfiDatePipeModule } from '../../../../pipes/format/legfi-date.module';
import { LegfiBalancePipeModule } from '../../../../pipes/format/legfi-balance.module';
import { LegfiBalancePipe } from '../../../../pipes/format/legfi-balance.pipe';
import { ButtonModule } from '../../../shared/button/button.module';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
        LegfiCurrencyPipeModule,
        LegfiDatePipeModule,
        LegfiBalancePipeModule,
        MatProgressSpinnerModule,
        ButtonModule,
    ], exports: [DepositDetailDialogComponent], declarations: [DepositDetailDialogComponent], providers: [
        LegfiCurrencyPipe,
        LegfiDatePipe,
        LegfiBalancePipe,
    ],
})
export class DepositDetailDialogModule
{
}
